// extracted by mini-css-extract-plugin
module.exports = {"container":"DocumentFilterAccordion_container__2CN5-","accordion":"DocumentFilterAccordion_accordion__3HA_d","active":"DocumentFilterAccordion_active__rcZ6b"};